// ***
// Returns window width
// ***
function windowWidth() {
	return $(window).width();
}

// ***
// Returns header height
// ***
function headerHeight() {
	return $('.header-main').outerHeight();
}

// ***
// Vh unit calculation for mobile
// ***
function calc_vh() {
	var vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh + 'px');
}

// ***
// Document ready
// ***
$(function () {
	//***
	// Sports Slider
	//***

	var sportsSlider = new Swiper('[data-slider="sports-slider"]', {
		slidesPerView: 'auto',
		spaceBetween: 20,
		navigation: {
			prevEl: '.sports-slider .slider-arrow.arrow-left',
			nextEl: '.sports-slider .slider-arrow.arrow-right'
		},
		pagination: {
			el: '.sports-slider .swiper-pagination',
			clickable: true
		},
		breakpoints: {
			750: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 20,
				allowTouchMove: false,
				simulateTouch: false
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 55,
				allowTouchMove: false,
				simulateTouch: false
			}
		}
	});

	//***
	// Blog Slider
	//***

	new Swiper('[data-slider="blog-slider"]', {
		slidesPerView: 'auto',
		spaceBetween: 20,
		navigation: {
			prevEl: '.blog-slider .slider-arrow.arrow-left',
			nextEl: '.blog-slider .slider-arrow.arrow-right'
		},
		pagination: {
			el: '.blog-slider .swiper-pagination',
			clickable: true
		},
		breakpoints: {
			750: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 20
			},
			1025: {
				slidesPerView: 4,
				spaceBetween: 20
			}
		}
	});

	$('.blog-slider__slide').matchHeight({
		property: 'min-height'
	});

	//***
	// Auto complate plugin
	// http://easyautocomplete.com/examples
	//***
	var autoCompleteOptions = {
		url: 'people.json',
		getValue: 'name',
		template: {
			type: 'description',
			fields: {
				description: 'email'
			}
		},
		list: {
			match: {
				enabled: true
			}
		}
	};

	$('[data-easyautocomplete]').each(function () {
		autoCompleteOptions.url = $(this).attr('data-json-path');
		$(this).easyAutocomplete(autoCompleteOptions);
	});

	//***
	// Open categories
	//***
	$('.sports-slider__button').on('click', function () {
		$(this).parents('.sports-slider__slide').find('.sports-slider__tags').slideToggle('fast');
		sportsSlider.update();
	});
});

// ***
// Document resize
// ***
window.addEventListener('resize', function () {
	calc_vh();
});
